import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(props, _ref) {
    var $, $on, $f7, $f7router, $f7route, $update, children, user, avatar, userLoggedIn, viewTutors, pin, keynumber, safeAttempts, abilitaTastiera, disabilitaTastiera, openFingerprint, setSafe, safeCancel, calcAge, updateForm, checkData, checkParentsAndTutor, deleteAvatar, rotateAvatar, storeAvatar, setAvatar, associaCard, insertCardNumber, saveQRScan, qrscan, save;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            $ = _ref.$, $on = _ref.$on, $f7 = _ref.$f7, $f7router = _ref.$f7router, $f7route = _ref.$f7route, $update = _ref.$update;

            /*
             * Valori iniziali
             */
            children = {}, user = {}, pin = [], keynumber = [], safeAttempts = 3;
            props.children = props.children || myApp.children;

            if (!(props.children !== '_new')) {
              _context11.next = 7;
              break;
            }

            myApp.getChildren(props.children).then(function (obj) {
              return children = obj;
            });
            _context11.next = 11;
            break;

          case 7:
            _context11.next = 9;
            return myApp.user();

          case 9:
            user = _context11.sent;
            children = {
              id: Date.now(),
              activation_code: user.activation_code,
              data: {
                pin: user.data.pin,
                ice: user.data.ice
              },
              username: user.username,
              verified: user.verified
            };

          case 11:
            children.data = children.data || {};
            _context11.next = 14;
            return myStorage.get(children.data.avatar);

          case 14:
            _context11.t1 = _context11.sent;

            if (_context11.t1) {
              _context11.next = 17;
              break;
            }

            _context11.t1 = children.data.avatar;

          case 17:
            _context11.t0 = _context11.t1;

            if (_context11.t0) {
              _context11.next = 20;
              break;
            }

            _context11.t0 = 'static/pet.svg';

          case 20:
            avatar = _context11.t0;
            userLoggedIn = myApp.userLoggedIn || false;
            /*
             * Evento di pagina: https://framework7.io/docs/router-component.html#component-page-events
             * 
             * Aggiorna user
             * Imposta tastiera numerica PIN
             */

            $on('pageMounted', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;

                      if (!(props.children !== '_new')) {
                        _context.next = 7;
                        break;
                      }

                      _context.next = 4;
                      return myApp.server.getJSON('user/me/children/' + props.children);

                    case 4:
                      children = _context.sent;
                      _context.next = 7;
                      return myApp.setChildren(children);

                    case 7:
                      _context.next = 9;
                      return myStorage.get(children.data.avatar);

                    case 9:
                      _context.t1 = _context.sent;

                      if (_context.t1) {
                        _context.next = 12;
                        break;
                      }

                      _context.t1 = children.data.avatar;

                    case 12:
                      _context.t0 = _context.t1;

                      if (_context.t0) {
                        _context.next = 15;
                        break;
                      }

                      _context.t0 = avatar;

                    case 15:
                      avatar = _context.t0;
                      $update();
                      _context.next = 22;
                      break;

                    case 19:
                      _context.prev = 19;
                      _context.t2 = _context["catch"](0);
                      console.log(_context.t2);

                    case 22:
                      _context.prev = 22;
                      $('#sex').val(children.data.sex);
                      $('#sterilized').val(children.data.sterilized);
                      calcAge();
                      return _context.finish(22);

                    case 27:
                      $('.safe').on('click', function (ev) {
                        setSafe($(ev.target).data('number'));
                      });

                    case 28:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[0, 19, 22, 27]]);
            })));
            /*
             * Evento di pagina: pageBeforeIn
             * https://framework7.io/docs/router-component.html#component-page-events
             * 
             * Imposta o controlla PIN
             */

            $on('pageBeforeIn', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      if ($f7route.query.pin === 'yes' && !myApp.secureMode) {
                        if ($f7.device.desktop) {
                          abilitaTastiera();
                        }

                        $f7.popup.open('.popup-safe', false);
                        openFingerprint();
                      }

                    case 1:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            })));

            abilitaTastiera = function abilitaTastiera() {
              console.log('abilitaTastiera');
            };

            disabilitaTastiera = function disabilitaTastiera() {
              console.log('disabilitaTastiera');
            };
            /**
             * Login con dati biometrici (Fingerprint / Analisi del viso)
             * 
             * Usa cordova-plugin-fingerprint-aio
             * cordova plugin add cordova-plugin-fingerprint-aio --variable FACEID_USAGE_DESCRIPTION="Per modificare i tuoi dati personali in sicurezza."
             * https://www.npmjs.com/package/cordova-plugin-ebw-fingerprint-aio
             * 0
             * @returns {undefined}
             */


            openFingerprint = function openFingerprint() {
              if ($f7.device.cordova) {
                var isAvailableSuccess = function isAvailableSuccess() {
                  Fingerprint.show({
                    description: lng.access_with_biometric_message
                  }, successCallback, function (errorCallback) {
                    return console.log(errorCallback);
                  });
                };

                var successCallback = function successCallback(res) {
                  myApp.enableSecure();
                  $('#safe-message').addClass('invisible');
                  $f7.popup.close('.popup-safe');
                  checkData();
                };

                Fingerprint.isAvailable(isAvailableSuccess, function () {
                  return console.log('Fingerprint not available');
                });
              }
            };
            /**
             * Chiede e controlla PIN
             * 
             * @param {type} number
             * @returns {undefined}
             */


            setSafe = function setSafe(number) {
              if (!safeAttempts) return;

              switch (number) {
                case 'null':
                  break;

                case 'back':
                  if (keynumber.length) {
                    keynumber.pop();
                  }

                  break;

                default:
                  if (keynumber.length === 3) {
                    keynumber.push(number);
                    var ok = true;
                    children.data.pin = children.data.pin || [];
                    keynumber.forEach(function (e, i) {
                      if (e !== children.data.pin[i]) ok = false;
                    });

                    if (ok) {
                      $('#safe-message').addClass('invisible');
                      myApp.enableSecure();
                      $f7.popup.close('.popup-safe');
                      checkData();
                    } else {
                      $('#safe-message').removeClass('invisible');
                      keynumber = [];
                      safeAttempts--;
                      $update();
                    }
                  } else {
                    keynumber.push(number);
                  }

              }

              $('.point').removeClass('point-fill');
              keynumber.forEach(function (e, i) {
                return $('.point-' + i).addClass('point-fill');
              });
            };
            /**
             * Annulla controllo PIN
             * 
             * @returns {undefined}
             */


            safeCancel = function safeCancel() {
              $f7router.back();
              $f7.popup.close('.popup-safe', false);
            };
            /*
             * Calcola l'età sulla base della data di nascita
             * @returns {undefined}
             */


            calcAge = function calcAge() {
              var birthdate = new Date(children.data.birthdate);
              var datediff = new Date(Date.now() - birthdate.getTime());
              var age = Math.abs(datediff.getUTCFullYear() - 1970);
              viewTutors = age < 18;
              $update();
            };
            /*
             * Aggiorna user.data alla modifica di un campo
             */


            updateForm = function updateForm(e) {
              children.data[e.target.id] = e.target.value; //checkParentsAndTutor();
            };

            checkData = function checkData() {
              return;
              var dataOk = true; // controlla dati richiesti

              myApp.userDataRequired.split(',').forEach(function (k) {
                if (!children.data[k]) {
                  dataOk = false;
                }
              });

              if (!dataOk) {
                var msg = lng.me_create_children_message;
                $f7.dialog.alert(msg);
              }
            };
            /*
             * Imposta i valori required e validate ai campi parent1, parent2 e tutor
             * sulla base dei diversi valori
             * @returns {undefined}
             */


            checkParentsAndTutor = function checkParentsAndTutor() {
              calcAge();
              if (!viewTutors) return;

              if ($f7.input.validate('#parent1_name') && $f7.input.validate('#parent1_lastname') && $f7.input.validate('#parent1_cf') && $f7.input.validate('#parent2_name') && $f7.input.validate('#parent2_lastname') && $f7.input.validate('#parent2_cf')) {
                $('#tutor_name').prop('required', false);
                $('#tutor_name').prop('validate', false);
                $('#tutor_lastname').prop('required', false);
                $('#tutor_lastname').prop('validate', false);
                $('#tutor_cf').prop('required', false);
                $('#tutor_cf').prop('validate', false);
              } else if ($f7.input.validate('#tutor_name') && $f7.input.validate('#tutor_lastname') && $f7.input.validate('#tutor_cf')) {
                $('#parent1_name').prop('required', false);
                $('#parent1_name').prop('validate', false);
                $('#parent1_lastname').prop('required', false);
                $('#parent1_lastname').prop('validate', false);
                $('#parent1_cf').prop('required', false);
                $('#parent1_cf').prop('validate', false);
                $('#parent2_name').prop('required', false);
                $('#parent2_name').prop('validate', false);
                $('#parent2_lastname').prop('required', false);
                $('#parent2_lastname').prop('validate', false);
                $('#parent2_cf').prop('required', false);
                $('#parent2_cf').prop('validate', false);
              } else {
                $('#tutor_name').prop('required', true);
                $('#tutor_name').prop('validate', true);
                $('#tutor_lastname').prop('required', true);
                $('#tutor_lastname').prop('validate', true);
                $('#tutor_cf').prop('required', true);
                $('#tutor_cf').prop('validate', true);
                $('#parent1_name').prop('required', true);
                $('#parent1_name').prop('validate', true);
                $('#parent1_lastname').prop('required', true);
                $('#parent1_lastname').prop('validate', true);
                $('#parent1_cf').prop('required', true);
                $('#parent1_cf').prop('validate', true);
                $('#parent2_name').prop('required', true);
                $('#parent2_name').prop('validate', true);
                $('#parent2_lastname').prop('required', true);
                $('#parent2_lastname').prop('validate', true);
                $('#parent2_cf').prop('required', true);
                $('#parent2_cf').prop('validate', true);
              }

              $update();
            };
            /*
             * Elimina avatar
             * @returns {undefined}
             */


            deleteAvatar = function deleteAvatar() {
              var old = children.data.avatar;
              $f7.dialog.confirm(lng.delete_image_message, function () {
                children.data.avatar = 'static/pet.svg';
                save().then(function () {
                  avatar = children.data.avatar;
                  $update();
                  myStorage.deleteItem(old);
                }).catch(function () {
                  return children.data.avatar = avatar;
                });
              });
            };
            /**
             * Ruota avatar in senso antiorario di 90°
             * @returns {undefined}
             */


            rotateAvatar = /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var old, data;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        $f7.preloader.show();
                        _context3.prev = 1;
                        old = children.data.avatar;
                        _context3.next = 5;
                        return myApp.server.postJSON('user/me/avatar/rotate', {
                          src: children.data.avatar,
                          children: props.children
                        });

                      case 5:
                        data = _context3.sent;
                        children.data.avatar = data.src;
                        avatar = children.data.avatar;
                        _context3.next = 10;
                        return myApp.setChildren();

                      case 10:
                        $update();
                        _context3.next = 13;
                        return storeAvatar(old);

                      case 13:
                        _context3.next = 18;
                        break;

                      case 15:
                        _context3.prev = 15;
                        _context3.t0 = _context3["catch"](1);
                        $f7.alertError(_context3.t0);

                      case 18:
                        _context3.prev = 18;
                        $f7.preloader.hide();
                        return _context3.finish(18);

                      case 21:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[1, 15, 18, 21]]);
              }));

              return function rotateAvatar() {
                return _ref5.apply(this, arguments);
              };
            }();

            storeAvatar = /*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(toDelete) {
                var b64;
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.next = 2;
                        return $f7.fetchImage(children.data.avatar);

                      case 2:
                        b64 = _context4.sent;

                        if (!b64) {
                          _context4.next = 7;
                          break;
                        }

                        _context4.next = 6;
                        return myStorage.set(children.data.avatar, b64);

                      case 6:
                        if (toDelete) myStorage.deleteItem(toDelete);

                      case 7:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              }));

              return function storeAvatar(_x3) {
                return _ref6.apply(this, arguments);
              };
            }();
            /*
             * Apre Action Sheet ed imposta avatar
             * 
             * Usa cordova-plugin-camera
             * https://github.com/apache/cordova-plugin-camera
             * 
             */


            setAvatar = function setAvatar(setAndSave) {
              if (setAndSave !== true && $(setAndSave.target).hasClass('f7-icons')) {
                return;
              }

              if (myApp.device.cordova) {
                $f7.actions.create({
                  buttons: [{
                    label: true,
                    text: lng.image_select_source,
                    color: 'gray'
                  }, {
                    icon: '<i class="icon f7-icons">camera</i>',
                    text: lng.camera,
                    color: 'blue',
                    onClick: function () {
                      var _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                        var old, data;
                        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                          while (1) {
                            switch (_context5.prev = _context5.next) {
                              case 0:
                                if (!$f7.device.android) {
                                  _context5.next = 6;
                                  break;
                                }

                                _context5.next = 3;
                                return myApp.cordova.cameraAndroidCrop();

                              case 3:
                                avatar = _context5.sent;
                                _context5.next = 9;
                                break;

                              case 6:
                                _context5.next = 8;
                                return myApp.cordova.camera({
                                  front: true,
                                  allowEdit: true,
                                  correctOrientation: true
                                });

                              case 8:
                                avatar = _context5.sent;

                              case 9:
                                $f7.preloader.show();
                                _context5.prev = 10;
                                old = children.data.avatar;
                                _context5.next = 14;
                                return myApp.server.postJSON('user/me/avatar', {
                                  img: avatar,
                                  children: props.children
                                });

                              case 14:
                                data = _context5.sent;
                                children.data.avatar = data.src;
                                _context5.next = 18;
                                return myApp.setChildren(children);

                              case 18:
                                $update();
                                if (setAndSave === true) save();
                                _context5.next = 22;
                                return myStorage.set(data.src, avatar);

                              case 22:
                                myStorage.deleteItem(old);
                                _context5.next = 28;
                                break;

                              case 25:
                                _context5.prev = 25;
                                _context5.t0 = _context5["catch"](10);
                                $f7.alertError(_context5.t0);

                              case 28:
                                _context5.prev = 28;
                                $f7.preloader.hide();
                                return _context5.finish(28);

                              case 31:
                              case "end":
                                return _context5.stop();
                            }
                          }
                        }, _callee5, null, [[10, 25, 28, 31]]);
                      }));

                      function onClick() {
                        return _onClick.apply(this, arguments);
                      }

                      return onClick;
                    }()
                  }, {
                    icon: '<i class="icon f7-icons">photo_on_rectangle</i>',
                    text: lng.gallery,
                    color: 'blue',
                    onClick: function () {
                      var _onClick2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                        var old, data;
                        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                          while (1) {
                            switch (_context6.prev = _context6.next) {
                              case 0:
                                if (!$f7.device.android) {
                                  _context6.next = 6;
                                  break;
                                }

                                _context6.next = 3;
                                return myApp.cordova.cameraAndroidCrop(true);

                              case 3:
                                avatar = _context6.sent;
                                _context6.next = 9;
                                break;

                              case 6:
                                _context6.next = 8;
                                return myApp.cordova.camera({
                                  allowEdit: true,
                                  gallery: true,
                                  correctOrientation: true
                                });

                              case 8:
                                avatar = _context6.sent;

                              case 9:
                                $f7.preloader.show();
                                _context6.prev = 10;
                                old = children.data.avatar;
                                _context6.next = 14;
                                return myApp.server.postJSON('user/me/avatar', {
                                  img: avatar,
                                  children: props.children
                                });

                              case 14:
                                data = _context6.sent;
                                children.data.avatar = data.src;
                                _context6.next = 18;
                                return myApp.setChildren(children);

                              case 18:
                                $update();
                                if (setAndSave === true) save();
                                _context6.next = 22;
                                return myStorage.set(data.src, avatar);

                              case 22:
                                myStorage.deleteItem(old);
                                _context6.next = 28;
                                break;

                              case 25:
                                _context6.prev = 25;
                                _context6.t0 = _context6["catch"](10);
                                $f7.alertError(_context6.t0);

                              case 28:
                                _context6.prev = 28;
                                $f7.preloader.hide();
                                return _context6.finish(28);

                              case 31:
                              case "end":
                                return _context6.stop();
                            }
                          }
                        }, _callee6, null, [[10, 25, 28, 31]]);
                      }));

                      function onClick() {
                        return _onClick2.apply(this, arguments);
                      }

                      return onClick;
                    }()
                  }, {
                    text: lng.cancel,
                    color: 'red'
                  }]
                }).open();
              } else {
                var fileInput = document.getElementById('imageDialogId');

                var openFileDialog = function openFileDialog() {
                  return fileInput.click();
                };

                fileInput.onchange = function (ev) {
                  var file = ev.target.files[0];
                  var reader = new FileReader();
                  reader.readAsDataURL(file);

                  reader.onload = function () {
                    avatar = reader.result;

                    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                      var old, data;
                      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                        while (1) {
                          switch (_context7.prev = _context7.next) {
                            case 0:
                              $f7.preloader.show();
                              _context7.prev = 1;
                              old = children.data.avatar;
                              _context7.next = 5;
                              return myApp.server.postJSON('user/me/avatar', {
                                img: avatar,
                                children: props.children
                              });

                            case 5:
                              data = _context7.sent;
                              children.data.avatar = data.src;
                              _context7.next = 9;
                              return myApp.setChildren(children);

                            case 9:
                              $update();
                              if (setAndSave === true) save();
                              _context7.next = 13;
                              return myStorage.set(data.src, avatar);

                            case 13:
                              myStorage.deleteItem(old);
                              _context7.next = 19;
                              break;

                            case 16:
                              _context7.prev = 16;
                              _context7.t0 = _context7["catch"](1);
                              $f7.alertError(_context7.t0);

                            case 19:
                              _context7.prev = 19;
                              $f7.preloader.hide();
                              return _context7.finish(19);

                            case 22:
                            case "end":
                              return _context7.stop();
                          }
                        }
                      }, _callee7, null, [[1, 16, 19, 22]]);
                    }))();
                  };

                  reader.onerror = function (error) {
                    console.log('Error: ', error);
                  };
                };

                openFileDialog();
              }
            };

            associaCard = function associaCard(message) {
              $f7.dialog.create({
                title: 'Associa Card DoctorPet',
                text: typeof message === 'string' ? message : 'Scegli un metodo per associare una Medaglietta DoctorPet',
                buttons: [{
                  text: 'Scansiona QR Code',
                  onClick: function onClick() {
                    return qrscan();
                  }
                }, {
                  text: 'Inserisci manualmente',
                  onClick: function onClick() {
                    return insertCardNumber();
                  }
                }, {
                  text: lng.cancel,
                  color: 'red',
                  close: true
                }],
                verticalButtons: true
              }).open();
            };

            insertCardNumber = function insertCardNumber() {
              $f7.dialog.prompt('Inserire il numero di Card o Medaglietta DoctorPet', function (text) {
                return text && saveQRScan({
                  text: text
                });
              });
            };

            saveQRScan = /*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(result) {
                var data;
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        console.log(result);

                        if (!result.text.match(myApp.qrscanpattern)) {
                          _context8.next = 23;
                          break;
                        }

                        $f7.preloader.show();
                        _context8.prev = 3;
                        _context8.next = 6;
                        return myApp.server.putJSON('user/me/cardnumber?children=' + props.children, result);

                      case 6:
                        data = _context8.sent;
                        console.log(data);
                        $f7.toast.show({
                          text: lng.associate_card_ok_message,
                          cssClass: 'bg-color-green text-color-white',
                          closeTimeout: 3000
                        });
                        children.cardnumber = data.cardnumber;
                        _context8.next = 12;
                        return myApp.setChildren(children);

                      case 12:
                        $update();
                        _context8.next = 18;
                        break;

                      case 15:
                        _context8.prev = 15;
                        _context8.t0 = _context8["catch"](3);
                        $f7.alertError(_context8.t0);

                      case 18:
                        _context8.prev = 18;
                        $f7.preloader.hide();
                        return _context8.finish(18);

                      case 21:
                        _context8.next = 25;
                        break;

                      case 23:
                        console.log(result.text.match(myApp.qrscanpattern), result.text, myApp.qrscanpattern);
                        $f7.dialog.alert(lng.card_cannot_be_associated);

                      case 25:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8, null, [[3, 15, 18, 21]]);
              }));

              return function saveQRScan(_x4) {
                return _ref8.apply(this, arguments);
              };
            }();
            /*
             * Associa card tramite qrscan
             * @returns {undefined}
             */


            qrscan = /*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                var result;
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        if (!myApp.device.cordova) {
                          _context9.next = 6;
                          break;
                        }

                        _context9.next = 3;
                        return myApp.cordova.qrscan();

                      case 3:
                        _context9.t0 = _context9.sent;
                        _context9.next = 9;
                        break;

                      case 6:
                        _context9.next = 8;
                        return $f7.pwaQrcodeScanner();

                      case 8:
                        _context9.t0 = _context9.sent;

                      case 9:
                        result = _context9.t0;
                        result.text && saveQrScan(result);

                      case 11:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9);
              }));

              return function qrscan() {
                return _ref9.apply(this, arguments);
              };
            }();
            /*
             * Salva
             */


            save = /*#__PURE__*/function () {
              var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
                var inputsvalid, avatarvalid, sexvalid, cardOK, res, res2, page;
                return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        inputsvalid = $f7.input.validateInputs('#validate');
                        avatarvalid = true; // avatar !== 'static/pet.svg';

                        sexvalid = $('#sex').val() !== '-';
                        cardOK = true; // children.cardnumber ? true : false;
                        // Controlla campi richiesti

                        if (!(inputsvalid && avatarvalid && sexvalid && cardOK)) {
                          _context10.next = 31;
                          break;
                        }

                        $f7.preloader.show();
                        _context10.prev = 6;
                        // invia al server
                        console.log('invia al server');
                        console.log(children.data, props.children);
                        _context10.next = 11;
                        return myApp.server.postJSON('user/me', {
                          user: children.data,
                          children: props.children
                        });

                      case 11:
                        res = _context10.sent;
                        console.log('res', res); // salva utente in Storage

                        _context10.next = 15;
                        return myApp.setChildren(children);

                      case 15:
                        res2 = _context10.sent;
                        console.log('res2', res2); // imposta myApp.userLoggedIn

                        userLoggedIn = true; // Mostra messaggio OK

                        $f7.toast.show({
                          text: lng.saved_ok,
                          cssClass: 'bg-color-green text-color-white',
                          closeTimeout: 3000
                        }); // Reindirizza alla pagina dei servizi oppure alla pagina ICE

                        page = children.data.ice || true ? '/services/' : '/ice/?showNext=yes';
                        window.setTimeout(function () {
                          return $f7router.navigate(page);
                        }, 1500);
                        _context10.next = 26;
                        break;

                      case 23:
                        _context10.prev = 23;
                        _context10.t0 = _context10["catch"](6);
                        $f7.alertError(_context10.t0);

                      case 26:
                        _context10.prev = 26;
                        $f7.preloader.hide();
                        return _context10.finish(26);

                      case 29:
                        _context10.next = 32;
                        break;

                      case 31:
                        if (inputsvalid && sexvalid && cardOK) {
                          // Dati completi ma senza immagine -> Apre procedura per caricare l'immagine
                          setAvatar(true);
                        } else if (inputsvalid && sexvalid) {
                          // Dati completi ma senza card -> Apre procedura per caricare card
                          associaCard('Devi associare una Medaglietta DoctorPet per continuare.');
                        } else {
                          // Dati incompleti -> mostra messaggio
                          $f7.toast.show({
                            text: lng.all_fields_are_required_message,
                            cssClass: 'bg-color-red text-color-white',
                            closeTimeout: 3000
                          });
                        }

                      case 32:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, _callee10, null, [[6, 23, 26, 29]]);
              }));

              return function save() {
                return _ref10.apply(this, arguments);
              };
            }();

            return _context11.abrupt("return", function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">

        <div class="left">
          <a href="/services/" class="link">
            <i class="f7-icons ios-only">arrow_left</i>
            <i class="material-icons md-only">arrow_back</i>
          </a>
        </div>

        <div class="title">
          <span class="padding-left"> PET </span>
        </div>

        <div class="right">
          <a href="#" class="link icon-only panel-open btn-menu" data-panel="right">
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div>

      </div>
    </div>
    <div class="page-content bg-color-white">

      <div class="block">
        <div class="avatar" @click=${setAvatar} style="background-image: url('${avatar}')">
          ${!avatar.match(/pet\.svg$/) && $h `
          <i class="f7-icons text-color-red" 
             style="border-radius: 50%;
             background-color: white;
             padding: 3px" 
             @click="${deleteAvatar}">trash</i>
          <i class="f7-icons text-color-white float-right" 
             style="border-radius: 50%;
             background-color: rgba(0,0,0,.5);
             padding: 3px" 
             @click="${rotateAvatar}">crop_rotate</i>
          `}
        </div>
      </div>

      <div class="list no-hairlines-md">
        <ul id="validate">
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.name} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} 
                        id="name" 
                        type="text" 
                        placeholder="${lng.pet_name}" 
                        required validate 
                        value=${children.data.name} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.type} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} 
                        id="lastname" 
                        type="text" 
                        placeholder="${lng.insert} ${lng.pet_type}" 
                        required validate 
                        value=${children.data.lastname} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.birthdate} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} 
                        id="birthdate" 
                        type="date" 
                        placeholder="${lng.insert} ${lng.birthdate}" r
                        equired validate 
                        value=${children.data.birthdate} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.sex} *</div>
              <div class="item-input-wrap">
                <select @change=${updateForm} id="sex" required validate pattern="[^\-]">
                  <option value=""></option>
                  <option value="M">M</option>
                  <option value="F">F</option>
                </select>
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.sterilized} *</div>
              <div class="item-input-wrap">
                <select @change=${updateForm} 
                         id="sterilized" 
                         required validate 
                         pattern="[^\-]">
                  <option value=""></option>
                  <option value="Y">${lng.yes}</option>
                  <option value="N">${lng.no}</option>
                </select>
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>

          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.identification_number}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} 
                        id="chip" 
                        value="${children.data.chip}" 
                        type="text" 
                        placeholder="${lng.insert} ${lng.identification_number}" />
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>

          <li>
            <div class="row">
              <div class="col-40">
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${lng.razza}</div>
                    <div class="item-input-wrap">
                      <input @change=${updateForm} 
                              id="razza" 
                              type="text" 
                              placeholder="${lng.insert} ${lng.razza}" 
                              value=${children.data.razza}/>
                      <span class="input-clear-button"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-60">
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${lng.size}</div>
                    <div class="item-input-wrap">
                      <input @change=${updateForm} 
                              id="taglia" 
                              type="text" 
                              placeholder="${lng.insert} ${lng.size}" 
                              value=${children.data.taglia}/>
                      <span class="input-clear-button"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="row">
              <div class="col-40">
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${lng.hair}</div>
                    <div class="item-input-wrap">
                      <input @change=${updateForm} 
                              id="pelo" 
                              type="text" 
                              placeholder="${lng.insert} ${lng.hair}" 
                              value=${children.data.pelo} />
                      <span class="input-clear-button"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-60">
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${lng.color}</div>
                    <div class="item-input-wrap">
                      <input @change=${updateForm} 
                              id="colore"
                              type="text" 
                              placeholder="${lng.insert} ${lng.color}" 
                              value=${children.data.colore} />
                      <span class="input-clear-button"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.weight}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} 
                        id="peso" 
                        type="text" 
                        placeholder="${lng.insert} ${lng.weight} (Kg)" 
                        value=${children.data.peso} />
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.use}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} 
                        id="impiego" 
                        type="text" 
                        placeholder="${lng.insert} ${lng.use}" 
                        value=${children.data.impiego} />
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>

          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.area_of_residence}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} 
                        id="zona_residenza" 
                        type="text" 
                        placeholder="${lng.insert} ${lng.area_of_residence}" 
                        value=${children.data.zona_residenza} />
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.particular_signs}</div>
              <div class="item-input-wrap">
                <textarea @change=${updateForm} 
                           id="segni_particolari" 
                           type="text" 
                           placeholder="${lng.insert} ${lng.particular_signs}">${children.data.segni_particolari}</textarea>
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>
        </ul>

        <div class="block">
          ${!(children.cardnumber || '') ? $h`
          <button @click=${associaCard} class="button button-large button-outline button-round">
            <img src="static/medaglietta.png" style="position: absolute; left: 15px" width="38"/> 
            ${lng.associate_tag}
          </button>
          ` : $h`
          <div class='display-flex justify-content-space-around align-items-center'>
            <img style='max-width: 50%' src='static/medaglietta.png' />
            <p class='text-align-right padding-left'>${lng.associate_tag_message}</p>
          </div>
          `}
        </div>

        <div class="block">
          <button @click=${save} class="button button-large button-fill button-round color-secondary">
            <i class="f7-icons left">square_arrow_right</i> ${lng.save}
          </button>
        </div> 
      </div>
    </div>

    <div @popup:close=${disabilitaTastiera} 
          class="popup popup-tablet-fullscreen popup-safe display-flex justify-content-center align-items-center flex-direction-column">
      <div class="block text-align-center">
        ${lng.insert_pin_message}
      </div>
      <div class="unselectable" style="width: 100%; max-width: 380px;">
        <div class="row text-align-center" style="max-width: 250px; margin: 0 auto; padding: 25px 0">
          <div class="col">
            <div class="point point-0"></div>
          </div>
          <div class="col">
            <div class="point point-1"></div>
          </div>
          <div class="col">
            <div class="point point-2"></div>
          </div>
          <div class="col">
            <div class="point point-3"></div>
          </div>
        </div>
        <div id="safe-message" class="text-align-center text-color-red invisible">
          ${lng.pin_error_message} <br/> 
          ${lng.attempts_left}: ${safeAttempts}
        </div>
        <div class="block text-align-center">
          <div class="row">
            <div class="col number-key safe" data-number="1">1</div>
            <div class="col number-key safe" data-number="2">2</div>
            <div class="col number-key safe" data-number="3">3</div>
          </div>
          <div class="row">
            <div class="col number-key safe" data-number="4">4</div>
            <div class="col number-key safe" data-number="5">5</div>
            <div class="col number-key safe" data-number="6">6</div>
          </div>
          <div class="row">
            <div class="col number-key safe" data-number="7">7</div>
            <div class="col number-key safe" data-number="8">8</div>
            <div class="col number-key safe" data-number="9">9</div>
          </div>
          <div class="row">
            <div class="col number-key safe" data-number="null"></div>
            <div class="col number-key safe" data-number="0">0</div>
            <div class="col number-key safe" data-number="back"><i class="f7-icons" data-number="back">delete_left</i></div>
          </div>
        </div>
      </div>
      <button class="button button-link text-color-gray" @click=${safeCancel}>Annulla</button>
    </div>

    <form style="display:none">
      <input type="file" accept="image/*" id="imageDialogId" />
    </form>

  </div>
`
    }
    );

          case 43:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
})();